let Api = {

    "B2B_FINDPRODUCTCOUNT": "/b2b/w/shopCart/findProductCount", //获取进货单数量



	"B2B_COMMSALECATG_LIST": "/b2b/n/commSaleCatg/list", //B2B查询一级类目及子类目
    "B2B_FINISHPROTAL_SAVE": "/b2b/w/FinishProtal/saveOrUpdate", //B2B装修保存
    "B2B_FINISHPROTAL_FINDPAGE": "/b2b/w/FinishProtal/findPageList", //B2B装修分页查询
    "B2B_FINISHPROTAL_FINDINFO": "/b2b/w/FinishProtal/findInfo", //B2B装修详情
    "B2B_FINISHPROTAL_FINDINFODEL": "/b2b/w/FinishProtal/del", //B2B装修删除
    "B2B_FINISHPROTAL_FINDINFOCOPY": "/b2b/w/FinishProtal/copy", //B2B装修复制
    "B2B_FINDDEFAULTINFO": "/b2b/n/finishProtal/findDefaultInfo", //B2B默认配置查询
	"B2B_W_INDUSTRYCOLUMNMANAGE_FINDLIST": "/b2b/n/IndustryColumnManage/findList", //栏目查询所有


	"PORTAL_COMMSALECATG_LIST": "/portal-api/n/commSaleCatg/list", //PORTAL查询一级类目及子类目
    "PORTAL_FINISHPROTAL_SAVE": "/portal-api/w/FinishProtal/saveOrUpdate", //PORTAL装修保存
    "PORTAL_FINISHPROTAL_FINDPAGE": "/portal-api/w/FinishProtal/findPageList", //PORTAL装修分页查询
    "PORTAL_FINISHPROTAL_FINDINFO": "/portal-api/w/FinishProtal/findInfo", //PORTAL装修详情
    "PORTAL_FINISHPROTAL_FINDINFODEL": "/portal-api/w/FinishProtal/del", //PORTAL装修删除
    "PORTAL_FINISHPROTAL_FINDINFOCOPY": "/portal-api/w/FinishProtal/copy", //PORTAL装修复制
    "PORTAL_FINDDEFAULTINFO": "/portal-api/n/finishProtal/findDefaultInfo", //PORTAL默认配置查询
	"PORTAL_W_INDUSTRYCOLUMNMANAGE_FINDLIST": "/portal-api/n/IndustryColumnManage/findList", //栏目查询所有
    "INDUSTRYCOLUMNMANAGE_FINDPAGELIST": "/portal-api/n/IndustryColumnManage/findList", //内容管理和关于我们模块分页查询列表
    "INDUSTRYMANGE_FINDDEFAULT": "/portal-api/n/IndustryMange/findDefault", //查询默认产业基本信息
    // 获取应用的首页模板

    "N_SYSTEMCONFIG_GETWEBBASECONFIG": "/b2b/n/systemConfig/getWebBaseConfig", //网站配置信息
    "N_SYSTEMCONFIG_GETWEBBASEPICCONFIG":"/b2b/n/systemConfig/getWebBasePicConfig", //网站图片配置
    "W_PERSON_GET": "/b2b/w/person/get", //获取个人信息

    "B2B_N_SHOPHOME_FINDESPRODUCTPAGELIST": "/b2b/n/ShopHome/findEsProductPageList", //商品列表
    "B2B_W_COMMSALECATG_LIST": "/b2b/n/ShopHome/commSaleCatg/list", //商品分类
    
    
    
}
module.exports = Api